// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";

function TbHexItemPreview(Props) {
  var itemId = Props.itemId;
  return React.createElement("div", {
              className: "w-[24px] h-[24px] border border-white1"
            }, React.createElement(ItemImage.make, {
                  itemId: itemId,
                  size: 22
                }));
}

var make = React.memo(TbHexItemPreview);

export {
  make ,
  
}
/* make Not a pure module */
